import React from 'react';

import { useTheme } from 'styled-components';

import { FaArrowLeft, FaArrowRight } from 'react-icons/fa';

import { Container } from './styles';

import { PaginationProps } from './interface';

const Pagination: React.FC<PaginationProps> = ({
  page,
  totalpages,
  onChange,
}) => {
  const { colors } = useTheme();

  const prev = () => {
    const cPage = page && page !== '' ? page : '1';
    let _page = Number(cPage) - 1;
    if (_page <= 1) {
      _page = 1;
    }
    onChange(`${_page}`);
  };

  const next = () => {
    const cPage = page && page !== '' ? page : '1';
    let _page = Number(cPage) + 1;
    onChange(`${_page}`);
  };

  const allPages = Array.from(
    { length: Number(totalpages && totalpages !== '' ? totalpages : 1) },
    (_, index) => index + 1,
  );

  if (allPages.length === 1) {
    return null;
  }

  const _page = page && page !== '' ? Number(page) : 1;
  const _totalpages = Number(totalpages);

  return (
    <Container>
      <button
        className="prev"
        onClick={prev}
        title="Página anterior"
        disabled={_page <= 1}
      >
        <FaArrowLeft size={18} color={colors.IC1} />
      </button>

      <main>
        <label title="Página Atual" htmlFor="page">
          {`${_page} de ${_totalpages}`}
        </label>
        <select
          id="page"
          name="page"
          value={_page}
          onChange={e => onChange(`${e.target.value}`)}
        >
          {allPages.map(cPage => (
            <option value={cPage}>{cPage}</option>
          ))}
        </select>
      </main>

      <button
        className="next"
        onClick={next}
        title="Próxima página"
        disabled={_page >= _totalpages}
      >
        <FaArrowRight size={18} color={colors.IC1} />
      </button>
    </Container>
  );
};

export default Pagination;
